import styled from 'styled-components'

const Container = styled.div`
  padding: 0 20px;
  min-height: 100%;
  border-bottom: 10px solid var(--dark-blue);
`
const SafeArea = styled.div`
  max-width: 710px;
  margin: 0 auto;
`
const Main = styled.main`
  box-sizing: border-box;
`
const Intro = styled.div`
  padding: 20px 0px 0px 0px;
  p {
    font-size: 20px;
    color: var(--dark-gray);
    margin-bottom: 0;
  }
  small {
    font-size: 12px;
    color: var(--dark-gray);
  }
`

const ValidationWarning = styled.small`
  font-size: 12px;
  text-align: right;
  display: block;
  margin-bottom: 30px;
  color: var(--red);
`

export { Container, Main, Intro, SafeArea, ValidationWarning }
